// @TODO fade is simply main colour at 20% opacity, so this file won't be needed...

import vars from '@variables';
export function getPageColour(pageColour) {
  switch (pageColour) {
    case 'Blue':
      return vars.plasticsBlue;
    case 'Light grey':
      return vars.lightGrey;
    case 'Orange':
      return vars.foodOrange;
    case 'Pink':
      return vars.financePink;
    case 'Purple':
      return vars.fashionPurple;
    case 'Slate grey':
      return vars.policyGrey;
    case 'Green':
      return vars.citiesGreen;
    case 'Yellow':
      return vars.designStrongYellow;
    case 'Red':
      return vars.builtEnvRed;
    case 'Turquoise':
      return vars.criticalMineralsTurquoise;
    case 'Dark grey':
    default:
      return vars.coreDarkGrey;
  }
}
